module.exports = __webpack_public_path__ + "img/minus-grey.e14e5a56.svg";